import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  mobileTriggerClicked(): void {
    if (!this.element.classList.contains('hidden')) {
      this.element.nextElementSibling?.classList.toggle('hidden')
    }
  }
}
